import { useSearchParams } from "react-router-dom";
import AddLookup from "../../../Components/InputComponents/AddLookup";

function AddEmploymentType() {
  const [searchParams] = useSearchParams();
  const redirectURL = `/EmploymentTypeLookup?${searchParams.toString()}`;

  return (
    <AddLookup
      title="Add Employment Type"
      alert="Employment Type Added Successfully"
      addDataAPIEndpoint="/EmpStatus/add"
      redirectURL={redirectURL}
      sections={[
        {
          fields: [
            {
              type: "text",
              label: "Employment Type",
              name: "ES_Name",
              required: true, // Validation rule added here
              maxLength:70
            },
            {
              type: "select",
              label: "Status",
              name: "ES_Status",
              required: true, // Validation rule added here       
              options: [
                { label: "Active", value:'1'},
                { label: "Inactive", value: '0'},
              ],
            },
          ],
        },
      ]}
      validationRules={{
        ES_Name: {
          required: true,
          
        },
        ES_Status: {
          required: true,
        },
      }}
    />
  );
}

export default AddEmploymentType;
